import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import {  useUser } from 'state/hooks'

const publicRouteHoc = ({ component: Component, ...rest }) => {


    // eslint-disable-next-line react-hooks/rules-of-hooks
    const user = useUser()
    console.log('USER ===', user)
    if(user && user.jwt && user.user.name) {
        return <Redirect to="/" />
    }

    return <Route {...rest} render={props => <Component {...props} />} />
}

export const PublicRoute = publicRouteHoc
